import { Box } from '@material-ui/core';
import { Comply, NaturalPersonRisk } from '@nemuru-eng/js-api-client';
import React from 'react';

import { useCustomTheme } from '../../../../../../../../../../hooks/useCustomTheme';

export const ScoringStatusTag = ({ comply }: { comply: NaturalPersonRisk['comply'] }) => {
  const { palette } = useCustomTheme();

  const getTagColorByStatus = () => {
    switch (comply) {
      case Comply.YES:
        return palette.success.main;
      case Comply.NO:
        return palette.error.main;
      case Comply.MAYBE:
        return palette.warning.main;
      default:
    }
  };

  return <Box height={12} width={12} borderRadius={6} bgcolor={getTagColorByStatus()} />;
};
